import React from 'react';

const LOGO_URL = "https://media-manager-c.questera.ai/greta-media/40a492dc43bc618e18a36c285588ccb1d2fe8075e2c19e16c3546447a7641f452c8a03ca0e53bb9227c01b726e9832ee/images/aW1hZ2UvcG5n/2c2b4a7af843ee8be69618d55b7182a1.png";

const LogoIcon = ({ className = "w-[52px] h-[52px]" }) => {
  return (
    <img 
      src={LOGO_URL} 
      alt="R. Venue Logo" 
      className={`object-contain ${className}`} 
    />
  );
};

export default LogoIcon;